import React from 'react';
import cn from 'classnames';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';

import * as Styles from '../Icon.module.scss';

export const CopyIcon = ({ size = 'medium' }: IconProps) => {
    const iconSize = IconSizes[size];
    const fillStyle = cn(Styles['dsgGreen'], Styles.fill);

    return (
        <svg
            width={iconSize}
            height={iconSize}
            className={fillStyle}
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm8 15h-3l-.117.007A1 1 0 0 0 24 16l.007.117A1 1 0 0 0 25 17h2v12h-8v-2l-.007-.117A1 1 0 0 0 17 27v3l.007.117A1 1 0 0 0 18 31h10l.117-.007A1 1 0 0 0 29 30V16l-.007-.117A1 1 0 0 0 28 15zm-6-6H12a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1zm-1 2v12h-8V11h8z"
                fillRule="evenodd"
            />
        </svg>
    );
};
